import { isLeftToRight } from '@picsart/rc/helpers';
import createUseStyles from '@picsart/rc/create';
import { FontSizes } from '@picsart/rc/fonts';

const useMenuSidebarStyles = createUseStyles(
  {
    root: {},
    closeIcon: {
      fontSize: FontSizes.Size_10,
      lineHeight: '16px',
      color: 'var(--texts-negative)',
      position: 'absolute',
      top: '5px',
      cursor: 'pointer',
      padding: '3px',

      [isLeftToRight()]: {
        right: '10px',
      },
      [isLeftToRight(false)]: {
        left: '10px',
      },
    },
    overlay: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      left: '0',
      top: '0',
      backgroundColor: 'var(--backgrounds-negative)',
      opacity: 0.2,
      zIndex: 5,
    },
    menuContainer: {
      position: 'fixed',
      left: '0',
      top: '0',
      height: '100%',
      minWidth: '200px',
      width: '45vw',
      backgroundColor: 'var(--backgrounds-positive)',
      padding: '60px 25px 25px 25px',
      boxShadow: '6px 0 18px 0 var(--backgrounds-negative)',
      overflow: 'hidden',
      zIndex: 6,

      '@media screen and (max-width: 540px)': {
        width: '75vw',
      },
      '@media screen and (max-width: 350px)': {
        width: '85vw',
      },
    },
  },
  { name: 'menu-sidebar' },
);

export default useMenuSidebarStyles;
